import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DataTable } from 'primereact/datatable';
import moment from 'moment-timezone';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { injectIntl, defineMessages } from 'react-intl';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import ManagementListHeader from './ManagementListHeader';
import { connectionShape, intlShape } from '../../../../../components/prop-types';
import Paginator from './ManagementListPaginator';

const messages = defineMessages({
  managers: { id: 'exec_report_detail.managers', defaultMessage: 'Managers' },
  date: { id: 'exec_report_detail.date', defaultMessage: 'Date' },
  template: { id: 'exec_report_detail.asmt_template', defaultMessage: 'Survey Template' },
  createdOn: { id: 'exec_report_detail.survey_created-on', defaultMessage: 'Created on' },
});

const managerName = rowData => <span>{rowData.managers}</span>;
const surveyTemplateName = rowData => <span>{rowData.template}</span>;

const selectManagerRow = (survey, { selectSpecTeam, selectedTeams }) => (
  <div>
    <Checkbox
      type="checkbox"
      id="selectAllManagers"
      onChange={() => {
        selectSpecTeam(survey.id);
      }}
      checked={ArrayUtil.isNotEmpty(selectedTeams) && selectedTeams.indexOf(survey.id) >= 0}
    />
  </div>
);

const HeaderManagers = (props) => {
  const { addAllTeams, isAllChecked, edges } = props;
  const allChecked = isAllChecked(edges);
  return (
    <div>
      <Checkbox
        type="checkbox"
        id="selectAllManagers"
        onChange={() => {
          addAllTeams(allChecked, edges);
        }}
        checked={allChecked}
      />
    </div>
  );
};

HeaderManagers.propTypes = {
  addAllTeams: PropTypes.func.isRequired,
  isAllChecked: PropTypes.func.isRequired,
  edges: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const timeFieldTemplate = (rowData, { formatDate, field }) => {
  const updated = formatDate(moment(rowData[field]), {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
  return updated;
};

class ManagementList extends Component {
  render() {
    const {
      connection: {
        edges, totalCount, indexFrom, indexTo, pageInfo,
      },
      intl: { formatMessage, formatDate },
      currentAccount,
      loading,
      selectSpecTeam,
      selectedTeams,
      addAllTeams,
      isAllChecked,
      onQueryChange,
      query,
      onTempChange,
      search,
      changePageSize,
      movePrev,
      moveNext,
    } = this.props;

    // data list
    const listRows = edges.map(({ node }) => ({
      ...node,
      managers: (node.self && node.self.respondent)
        ? `${node.self.respondent.firstName} ${node.self.respondent.lastName}`
        : '',
      template: node.template ? node.template.title : '',
      createdOn: node.createdOn,
    }));

    // header
    const headerManagers = formatMessage(messages.managers);
    const headerTemplate = formatMessage(messages.template);
    const headerCreatedOn = formatMessage(messages.createdOn);

    const headerManagerTemplate = (
      <HeaderManagers
        addAllTeams={addAllTeams}
        isAllChecked={isAllChecked}
        edges={listRows}
      />
    );

    // footer
    const footer = (
      <Paginator
        totalCount={totalCount}
        indexFrom={indexFrom}
        indexTo={indexTo}
        pageInfo={pageInfo}
        search={search}
        changePageSize={changePageSize}
        movePrev={movePrev}
        moveNext={moveNext}
      />
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <div className="p-grid">
              <div className="p-col-12">
                <ManagementListHeader
                  onQueryChange={onQueryChange}
                  onTempChange={onTempChange}
                  query={query}
                />
              </div>
              <div className="p-col-12">
                <DataTable
                  value={listRows}
                  responsive
                  lazy
                  footer={footer}
                  loading={loading}
                >
                  <Column
                    style={{ textAlign: 'center', width: '3em' }}
                    field="id"
                    header={headerManagerTemplate}
                    body={selectManagerRow}
                    selectSpecTeam={selectSpecTeam}
                    selectedTeams={selectedTeams}
                  />
                  <Column field="title" header={headerManagers} currentAccount={currentAccount} body={managerName} />
                  <Column field="template" header={headerTemplate} body={surveyTemplateName} />
                  <Column
                    field="createdOn"
                    header={headerCreatedOn}
                    body={timeFieldTemplate}
                    formatDate={formatDate}
                    sortable
                  />
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ManagementList.propTypes = {
  connection: connectionShape.isRequired,
  intl: intlShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  selectSpecTeam: PropTypes.func.isRequired,
  selectedTeams: PropTypes.arrayOf(PropTypes.any),
  addAllTeams: PropTypes.func.isRequired,
  isAllChecked: PropTypes.func.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  onTempChange: PropTypes.func.isRequired,
  search: PropTypes.objectOf(PropTypes.any).isRequired,
  changePageSize: PropTypes.func.isRequired,
  movePrev: PropTypes.func.isRequired,
  moveNext: PropTypes.func.isRequired,
};

ManagementList.defaultProps = {
  selectedTeams: [],
};

export default injectIntl(ManagementList);
